export enum EDatasheetFields {
  Anatel = 'anatel',
  Anvisa = 'anvisa',
  Mapa = 'mapa',
  Modelo = 'modelo',
  Garantia = 'garantia',
}

export enum EDatasheetFieldsForEditComplex {
  Anatel = 'anatel',
  Anvisa = 'anvisa',
  Mapa = 'mapa',
}

export const DATASHEET_TYPES: Record<string, string> = {
  [EDatasheetFields.Anatel]: 'Certificado de homologação da ANATEL',
  [EDatasheetFields.Anvisa]: 'Registro do produto ANVISA',
  [EDatasheetFields.Mapa]: 'Registro do produto Ministério da Agricultura (MAPA)',
  [EDatasheetFields.Modelo]: 'Modelo',
  [EDatasheetFields.Garantia]: 'Garantia',
}

export const NOT_APPLICABLE_FIELD_VALUE = 'Não se aplica'
